import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { IEmployeeUserSearchDataDTO } from "../models/employeeuser/employeeUserSort";
import { EmployeeUserEditModel } from "../models/employeeuser/employeeUserEdit";
import { SendResetPasswordMailRequestModel } from "../models/users/sendResetPasswordMailRequest";
import { UserOwnedProjectModel } from "../models/employeeuser/userOwnedProjectDTO";
import { ProjectOwnerDetailsModel } from "../models/employeeuser/projectOwnerDetails";
let EmployeeUserModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    let EmployeeUserModule = class EmployeeUserModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "EmployeeUser";
            this.users = null;
            this.validEmployees = [];
            this.employeeUsers = [];
            this.editEmployeeUser = new EmployeeUserEditModel();
            this.totalUsers = 0;
            this.roles = [];
            this.userOwnedProjectDetails = [];
        }
        //Actions
        //List
        async GetAllUsers(searchData) {
            var url = `${getTenantId()}/${this.apiNode}` + "/GetAllUsers";
            let { data } = await service.post(url, searchData);
            if (data) {
                this.ListUsers(data);
                return data;
            }
        }
        ListUsers(data) {
            this.users = data.employeeUsers;
            this.totalUsers = data.totalCount;
            this.roles = data.roles;
        }
        //Get Email-Id
        async GetEmployeesEmailId() {
            var url = `${getTenantId()}/${this.apiNode}` + "/EmployeeEmail";
            let { data } = await service.get(url);
            if (data) {
                this.ListEmailId(data);
                return data;
            }
        }
        async DeActivateUser(userId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "deactivate/" + userId;
            let { data } = await service.put(url);
            if (data) {
                return data;
            }
        }
        async CanDeactivateUser(userId) {
            var url = `${getTenantId()}/${this.apiNode}/can-deactivate?userId=${userId}`;
            let { data } = await service.get(url);
            if (data) {
                return data;
            }
        }
        async ActivateUser(userId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "activate/" + userId;
            let { data } = await service.put(url);
            if (data) {
                return data;
            }
        }
        ListEmailId(validEmployees) {
            this.validEmployees = validEmployees;
        }
        //Add
        async AddEmployeeUser(employeeUser) {
            var url = `${getTenantId()}/EmployeeUser`;
            let { data } = await service.post(url, employeeUser);
            return data;
        }
        async GetAllEmployeeUsers() {
            var url = `${getTenantId()}/${this.apiNode}` + "/EmployeeUsers";
            let { data } = await service.get(url);
            if (data) {
                this.SetEmployeeUsers(data);
                return data;
            }
        }
        SetEmployeeUsers(employeeUsers) {
            this.employeeUsers = employeeUsers;
        }
        async EditEmployeeUserById(employeeUserId) {
            var url = `${getTenantId()}/${this.apiNode}/Edit/` + employeeUserId;
            let { data } = await service.get(url);
            if (data) {
                this.SetEditEmployeeUser(data);
                return data;
            }
        }
        SetEditEmployeeUser(data) {
            this.editEmployeeUser = data.employeeUser;
        }
        async UpdateEmployeeUser(updateEmployee) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.put(url, updateEmployee);
            return data;
        }
        async ResendInvitation(request) {
            let { data } = await service.post(`User/sendResetPasswordMail`, request);
            return data;
        }
        async HostileTakeoverUserProjectDetails(userId) {
            var url = `${getTenantId()}/${this.apiNode}/hostile-takeover/defaults?userId=${userId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetUserOwnedProjectDetails(plainToClass(UserOwnedProjectModel, data.ownedProjectDetails));
                return data;
            }
        }
        async saveHostileTakeoverUserProjectDetails(payload) {
            var url = `${getTenantId()}/${this.apiNode}` + "/hostile-takeover";
            let { data } = await service.post(url, payload);
            if (data) {
                return data;
            }
        }
        SetUserOwnedProjectDetails(ownedProjectDetails) {
            this.userOwnedProjectDetails = ownedProjectDetails;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IEmployeeUserSearchDataDTO !== "undefined" && IEmployeeUserSearchDataDTO) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], EmployeeUserModule.prototype, "GetAllUsers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EmployeeUserModule.prototype, "ListUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], EmployeeUserModule.prototype, "GetEmployeesEmailId", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeUserModule.prototype, "DeActivateUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], EmployeeUserModule.prototype, "CanDeactivateUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof Guid !== "undefined" && Guid) === "function" ? _g : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeUserModule.prototype, "ActivateUser", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeUserModule.prototype, "ListEmailId", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], EmployeeUserModule.prototype, "AddEmployeeUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], EmployeeUserModule.prototype, "GetAllEmployeeUsers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeUserModule.prototype, "SetEmployeeUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof Guid !== "undefined" && Guid) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], EmployeeUserModule.prototype, "EditEmployeeUserById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EmployeeUserModule.prototype, "SetEditEmployeeUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof EmployeeUserEditModel !== "undefined" && EmployeeUserEditModel) === "function" ? _m : Object]),
        __metadata("design:returntype", Promise)
    ], EmployeeUserModule.prototype, "UpdateEmployeeUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof SendResetPasswordMailRequestModel !== "undefined" && SendResetPasswordMailRequestModel) === "function" ? _o : Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], EmployeeUserModule.prototype, "ResendInvitation", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof Guid !== "undefined" && Guid) === "function" ? _q : Object]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], EmployeeUserModule.prototype, "HostileTakeoverUserProjectDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof ProjectOwnerDetailsModel !== "undefined" && ProjectOwnerDetailsModel) === "function" ? _s : Object]),
        __metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
    ], EmployeeUserModule.prototype, "saveHostileTakeoverUserProjectDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EmployeeUserModule.prototype, "SetUserOwnedProjectDetails", null);
    EmployeeUserModule = __decorate([
        Module({ dynamic: true, store: store, name: "employeeUser", namespaced: true })
    ], EmployeeUserModule);
    return EmployeeUserModule;
})();
export default getModule(EmployeeUserModule);
